import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as Actions from "../actions/SerialNumberActions";
import {showModalWindow, removeModalWindow} from "../actions/WindowActions";

function* requestShowSerialNumbers(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SerialNumbersWindow", {serialNrs: baseAction.serialNrs}, baseAction.title));
  yield take(Actions.CLOSE_SERIAL_NUMBERS);
  yield put(removeModalWindow(windowId));
}
function* watchRequestShowSerialNumbers() {
  yield takeLatest(Actions.REQUEST_SHOW_SERIAL_NUMBERS, requestShowSerialNumbers);
}

export default function* saga() {
  yield fork(watchRequestShowSerialNumbers);
}
